import { BaseHttpResponse, ListHttpResponse } from "../../_common/models/core.model";
import { PrinterMechanismStatusEnum } from "./printers-status.enum";

export interface PrintersStatusModel {
    shopName: string,
    shopNumber: string,
    printerName: string,
    printerUniqueNumber: string,
    printerEvidenceNumber: string,
    printerIp: string,
    printerPort: number,
    receiptCount: number,
    dailyReportCount: number,
    dataFrom: Date,
    dataTo: Date,
    lastCommunicationDate: Date,
    daysSinceLastCommunication: number,
    isActive: boolean,
    printerMechanismStatus: PrinterMechanismStatusEnum,
}

export interface PrintersStatusListResponse extends ListHttpResponse<PrintersStatusModel> { }

export interface PrinterMechanismStatusResponse extends BaseHttpResponse<PrinterMechanismStatusEnum> { }

